import { SubCapabilityKey } from "@next-platform/packages-ts-types";
import { useCallback } from "react";
import useEventCapabilityIsUsed from "../../../services/databricks/hooks/useEventCapabilityIsUsed";
import { useAppDispatch } from "../../hook";
import { openViewMediaModal } from "./viewMediaModalSlice";
/**
 * Opens the details modal, and reads nothing.
 *
 * A surface that only ever opens the modal uses this rather than `useViewMediaModal`: that one subscribes to
 * the open file and the list around it, so a page holding it re-renders on every open and every step. For a
 * long chat that is every message bubble, for a file the page does not otherwise care about.
 *
 * Opening is the usage moment of the details modal, from a gallery tile and from a chat image alike, so the
 * usage event is raised here once per open. Stepping inside the open modal is its own capability.
 */
export default function useOpenViewMediaModal() {
    const dispatch = useAppDispatch();
    const raiseEventCapabilityIsUsed = useEventCapabilityIsUsed();
    return useCallback((fileId, fileIds, blurVerdicts) => {
        raiseEventCapabilityIsUsed(SubCapabilityKey.GalleryOpenMediaDetails);
        dispatch(openViewMediaModal({ fileId, ...(fileIds !== undefined && { fileIds }), ...(blurVerdicts !== undefined && { blurVerdicts }) }));
    }, [dispatch, raiseEventCapabilityIsUsed]);
}
